import React from 'react';
import cx from 'clsx';
import loadable from '@loadable/component';
import ProductHeadline from '../Headline/ProductHeadline';
import ProductImages from './ProductImages';
import ProductBadge from './ProductBadge';
import SpecTabs from './SpecTabs';
import MdToHtml from '../MdToHtml';
import { Mobile, NotMobile } from '../MediaQuery';
import ProductSpecDetailTable from '../ProductSpecDetailTable';
import * as themeStyles from '../../assets/theme.module.scss';

const SpecExpansion = loadable(() => import('./SpecExpansion'));

const ProductPage = ({
    name,
    desc,
    feature,
    spec,
    certificate,
    images,
    tags,
    specDetail,
    productSpecDetail,
    specPdfLink,
}) => {
    const tabContent = [
        // {
        //     name: '產品描述',
        //     key: 'desc',
        //     content: desc,
        // },
        {
            name: specDetail ? '其他規格' : '產品規格',
            key: 'specDetail',
            type: 'table',
            content: productSpecDetail || null,
            specPdfLink: specPdfLink || null,
        },
        {
            name: '產品特色',
            key: 'feature',
            type: 'md',
            content: feature ? feature.feature : null,
        },
        {
            name: '產品規格',
            key: 'spec',
            type: 'md',
            content: spec && !productSpecDetail ? spec.spec : null,
        },
        {
            name: '產品認證',
            key: 'certificate',
            type: 'md',
            content: certificate ? certificate.certificate : null,
        },
    ].filter((item) => item.content);

    return (
        <div className={cx(themeStyles.mtMd5, themeStyles.mb7)}>
            <div className={themeStyles.container}>
                <div className={cx(themeStyles.row, themeStyles.mb8)}>
                    <div className={cx(themeStyles.colSm5, { vhcenter: images.length === 1 })}>
                        <ProductImages images={images} name={name} />
                    </div>
                    <div className={cx(themeStyles.colSm7)}>
                        <div className={cx(themeStyles.mtMd5, themeStyles.mtSm3)}>
                            <ProductHeadline title={name} />
                            {tags && tags.length
                                ? (
                                    <div className={themeStyles.mb2}>
                                        {tags.map((tag) => (
                                            <ProductBadge key={tag.url} type={tag.url} name={tag.name} />
                                        ))}
                                    </div>
                                )
                                : null}
                            {specDetail
                                ? <ProductSpecDetailTable headers={specDetail.headers} rows={specDetail.rows} hasLink={false} showDitto />
                                : null}
                            <MdToHtml data={desc.desc} />
                        </div>
                    </div>
                </div>
            </div>
            <NotMobile>
                <SpecTabs tabContent={tabContent} />
            </NotMobile>
            <Mobile>
                <SpecExpansion tabContent={tabContent} />
            </Mobile>
        </div>
    );
};

export default ProductPage;
